import { hasValue } from '../helpers';
import { AvatarControllerModel } from './avatar';
export class MeControllerModel {
    $translate;
    $mdDialog;
    log;
    webClientService;
    receiverType = 'me';
    subject;
    isLoading = false;
    me;
    avatarController;
    nickname;
    mode = "view";
    constructor($translate, $mdDialog, logService, webClientService, mode, me) {
        this.log = logService.getLogger('Me-CM');
        this.$translate = $translate;
        this.$mdDialog = $mdDialog;
        this.me = me;
        this.webClientService = webClientService;
        this.mode = mode;
        this.nickname = webClientService.me.publicNickname || '';
        switch (mode) {
            case "edit":
                this.subject = $translate.instant('messenger.EDIT_RECEIVER');
                this.avatarController = new AvatarControllerModel(logService, this.webClientService, this.me);
                break;
            case "view":
                this.subject = $translate.instant('messenger.MY_THREEMA_ID');
                break;
            default:
                this.log.error('Invalid controller model mode: ', this.getMode());
        }
    }
    setOnRemoved(callback) {
    }
    getMode() {
        return this.mode;
    }
    canClean() {
        return false;
    }
    clean(ev) {
    }
    isValid() {
        return (this.me !== null
            && this.me !== undefined
            && this.me.id === this.webClientService.me.id);
    }
    canChat() {
        return false;
    }
    canEdit() {
        const mdm = this.webClientService.appCapabilities.mdm;
        return mdm === undefined || !mdm.readonlyProfile;
    }
    canShowQr() {
        return true;
    }
    save() {
        switch (this.getMode()) {
            case "edit":
                return this.webClientService.modifyProfile(this.nickname, this.avatarController.avatarChanged ? this.avatarController.getAvatar() : undefined).then(() => {
                    this.webClientService.me.publicNickname = this.nickname;
                    if (this.avatarController.avatarChanged) {
                        const avatar = this.avatarController.getAvatar();
                        if (avatar) {
                            if (!hasValue(this.webClientService.me.avatar)) {
                                this.webClientService.me.avatar = { high: avatar };
                            }
                            else {
                                this.webClientService.me.avatar.high = avatar;
                            }
                        }
                    }
                    return this.me;
                });
            default:
                this.log.error('Not allowed to save profile: Invalid mode');
                return Promise.reject('unknown');
        }
    }
}
